import React, { useState, useEffect } from 'react'
import UnifiedChatPanel from './components/UnifiedChatPanel'
import LoginModal from './components/LoginModal'
import './App.css'

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [showLoginModal, setShowLoginModal] = useState(false)

  // 检查登录状态
  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token) {
      setIsLoggedIn(true)
    } else {
      setShowLoginModal(true)
    }
  }, [])

  // 处理登录成功
  const handleLoginSuccess = (token: string) => {
    setIsLoggedIn(true)
    setShowLoginModal(false)
  }

  // 处理登录模态框关闭
  const handleLoginModalClose = () => {
    setShowLoginModal(false)
  }

  return (
    <div className="app">
      {isLoggedIn ? (
        <UnifiedChatPanel />
      ) : (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          fontSize: '16px',
          color: '#666'
        }}>
          请先登录
        </div>
      )}
      
      <LoginModal
        visible={showLoginModal}
        onClose={handleLoginModalClose}
        onLoginSuccess={handleLoginSuccess}
      />
    </div>
  )
}

export default App 